import type { QueryKey } from '@tanstack/react-query';

export const PAYMENT_STATUS_KEY = (residentId: string): QueryKey => [
  `PAYMENT_STATUS-${residentId}`,
];
